import script from "./assessmentList.vue?vue&type=script&setup=true&lang=js"
export * from "./assessmentList.vue?vue&type=script&setup=true&lang=js"

import "./assessmentList.vue?vue&type=style&index=0&id=0acc755c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acc755c"]])

export default __exports__